import * as Sentry from "@sentry/react";
import React from "react";
import type { LoaderFunctionArgs } from "react-router-dom";

import ScimLog from "./components/ScimLog";

import { currentUserQuery, scimLogsQuery } from "../../../../api/queries";
import type { SimplifiedQuery } from "../../../../api/queries/dataLoader";
import { dataLoader } from "../../../../api/queries/dataLoader";

import config from "./config";

const { pageSize, debounceLength } = config;

// Data loader function
export const scimLogLoader = ({ params }: LoaderFunctionArgs) => {
	const { scimId } = params;

	const queries: (() => SimplifiedQuery)[] = [];

	if (scimId) {
		queries.push(() =>
			scimLogsQuery({
				scimId: scimId,
				limit: pageSize,
				skip: 0,
			})
		);
	}

	return dataLoader([[currentUserQuery], queries]);
};

const ViewSyncLog = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<ScimLog pageSize={pageSize} debounceLength={debounceLength} />
		</Sentry.ErrorBoundary>
	);
};

export default ViewSyncLog;
